"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALENDAR_PERFORMANCE_DATA_QUERY = exports.WORKSPACE_PERFORMANCE_COLUMNS_QUERY = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
// Cheap list of the workspace's performance columns — used to populate the
// calendar Statistics dropdown with the metrics flagged `displayedInCalendar`.
// No aggregation here, so it's safe to load whenever the Statistics row shows.
exports.WORKSPACE_PERFORMANCE_COLUMNS_QUERY = (0, graphql_tag_1.default) `
  query CalendarWorkspacePerformanceColumns($workspaceId: ID!) {
    workspace(id: $workspaceId) {
      performanceColumns {
        id
        name
        displayAs
        displayedInCalendar
      }
    }
  }
`;
// Leaner than the perf-table query on purpose: the calendar only needs the
// per-row values to draw the line (no summary / totalRows / splitName), so we
// don't pull data we won't render.
exports.CALENDAR_PERFORMANCE_DATA_QUERY = (0, graphql_tag_1.default) `
  query CalendarPerformanceData(
    $workspaceId: ID!
    $period: PeriodInput!
    $rowUnit: PerformanceRowUnit
  ) {
    workspace(id: $workspaceId) {
      performanceData(period: $period, rowUnit: $rowUnit) {
        columns {
          id
          tag
          displayAs
        }
        rows {
          hour
          period {
            start
          }
          cells {
            columnTag
            value
          }
        }
      }
    }
  }
`;
